import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import Login from "./Pages/Login";
import PCB from "./Pages/services/PCB";
import Prototyping from "./Pages/services/Prototyping";
import Fabrication from "./Pages/services/Fabrication";
import Supply from "./Pages/services/Supply";
import System from "./Pages/services/System";
import About from "./Pages/company/About";
import Mission from "./Pages/company/Mission";
import CustomerFocus from "./Pages/company/CustomerFocus";
import ProductFocus from "./Pages/company/ProductFocus";
import Quality from "./Pages/company/Quality";
import Register from "./Pages/Register";

function App() {
  return (
    <div>
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />

        {/* Services Dropdown Pages */}
        <Route path="/service/PCB" element={<PCB />} />
        <Route path="/service/Prototyping" element={<Prototyping />} />
        <Route path="/service/Fabrication" element={<Fabrication />} />
        <Route path="/service/Supply" element={<Supply />} />
        <Route path="/service/System" element={<System />} />

        {/* Company Dropdown Pages */}
        <Route path="/About" element={<About />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/customer-focus" element={<CustomerFocus />} />
        <Route path="/product-focus" element={<ProductFocus />} />
        <Route path="/quality" element={<Quality />} />

        <Route path="/register" element={<Register />} />
      </Routes>
    </div>
  );
}

export default App;